import { TEAM_SCENARIOS } from "../data/proposal";

const stats = [
  { value: "2 倍以上", label: "公司團建詢問量" },
  { value: "600 萬", label: "目前團建業績／月（總業績 3,000 萬的 1/5）" },
];

export const BonusTeam = () => (
  <div className="mt-6 max-w-3xl">
    <div className="space-y-4 self-start">
      <div className="grid grid-cols-2 gap-4">
        {stats.map((s, i) => (
          <div key={s.label} data-testid={`team-stat-${i}`} className="rounded-3xl bg-[var(--teal-d)] p-6 text-white">
            <p className="text-2xl font-black md:text-4xl">{s.value}</p>
            <p className="mt-2 text-sm text-white/85">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="rounded-3xl border border-[var(--line)] p-5">
        <p className="text-sm font-black text-[var(--teal-d)]">團建業績每月增加（三種情況）</p>
        <div className="mt-3 grid grid-cols-3 gap-3">
          {TEAM_SCENARIOS.map((s) => (
            <div key={s.name} data-testid={`team-scenario-${s.name}`} className="rounded-2xl bg-[#47BBBC]/10 p-3 text-center">
              <p className="text-xs font-bold text-[var(--text)]">{s.name} {s.rate}</p>
              <p className="mt-1 text-xl font-black text-[var(--teal-d)] md:text-2xl">{s.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
